<template>
    <div>
        <vs-row class="p-4">
            <vs-col w="12" class="lineTitulo mb-2">
                <h5><strong>PERFIL</strong></h5>
            </vs-col>
            <vs-col w="12" class="component-timeline">
                <v-timeline-item :position="tiempo.position" v-for="(tiempo, i) in pasos" :key="i"
                :bg-color="((informacion && informacion.status_id) == tiempo.status) ? 'primary' : ((informacion && informacion.status_id) > tiempo.status && (informacion && informacion.status_id) < 6) ? 'success' : 'secondary'">
                    <div class="cardInfo borderCarta" :style="((informacion && informacion.status_id) != tiempo.status) ? 'background: #ededed' : ''">
                        <div class="d-flex justify-space-between align-items-center">
                            <h6><strong>{{tiempo.title}}</strong></h6>
                            <!-- MENÚ -->
                            <div v-if="(informacion && informacion.status_id) == tiempo.status">
                                <vs-button
                                    shadow
                                    data-toggle="dropdown"
                                    @click="active = 2"
                                    style="font-size: 1rem;"
                                >
                                    <i class="fas fa-ellipsis-v"></i>
                                </vs-button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <button v-if="tiempo.inscripcion == true" class="dropdown-item" >
                                            <a :href="'/proceso-inscripcion/persona/' + window.btoa(informacion.persona_id)" target="_blank">
                                                Inscripción académica
                                            </a>
                                        </button>
                                        <button v-if="tiempo.pagar == true" class="dropdown-item" >
                                            <a :href="'/finanzas/' + window.btoa(informacion.persona_id)" target="_blank">
                                                Pago de inscripción
                                            </a>
                                        </button>
                                        <button class="dropdown-item" @click="hacerComentarios(i)">
                                            Hacer un comentario
                                        </button>
                                        <!-- <button class="dropdown-item"
                                            id="#enviarCorreo"
                                            @click="abrirCorreoModal(tiempo.status)">
                                            Enviar correo
                                        </button> ya estaba comentado--> 
                                         <button class="dropdown-item" @click="postCongelar(informacion.id)">Congelar</button>
                                        <button class="dropdown-item" @click="postDescartar(informacion.id)">Descartar</button>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <!-- DESCRIPCIÓN DE LA ETAPA -->
                            <div class="cardAlerta" v-if="(informacion && informacion.status_id) == tiempo.status">
                                {{tiempo.tooltip}}
                            </div>
                            <vs-button
                                class="mb-3"
                                warn
                                v-if="([6,7]).includes((informacion && informacion.status_id))"
                                @click="postReactivar(tiempo.status, informacion.id)"
                            >
                                Reactivar en esta etapa
                            </vs-button>
                            <!-- <button v-if="([6,7]).includes(informacion.status_id)" class="btn btn-sm btn-warning mb-2" @click="postReactivar(tiempo.status, informacion.id)">
                                Reactivar en esta etapa
                            </button> ya estaba comentado -->
                            <h6 class="m-0 mb-1 mt-2">Comentarios</h6>
                            <!-- HACER COMENTARIOS -->
                            <div v-show="show_comentarios[i]" :key="componentKey">
                                <textarea v-model="comentarios" class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Hacer un comentario..."></textarea>
                                <div class="text-right mt-1 comment-area">
                                    <vs-button
                                        danger
                                        border
                                        @click="hacerComentarios(i), comentarios = ''"
                                    >
                                        Cancelar
                                    </vs-button>
                                    <vs-button
                                        @click="publicarComentario(informacion.id)"
                                    >
                                        Guardar
                                    </vs-button>
                                </div>
                            </div>
                            <!-- COMENTARIOS HECHOS -->
                            <div v-for="(item, j) in (informacion && informacion.comentarios)" :key="j">
                                <div class="mt-3 component-comment" v-if="item.status_id == tiempo.status">
                                    <hr>
                                    <div class="user mb-2">
                                        <vs-avatar>
                                            <template #text>
                                                {{item.user.name}}
                                            </template>
                                        </vs-avatar>
                                        <div class="d-inline-block pl-2">
                                            <p class="d-block username m-0">{{item.user.name}}<span v-if="item.nuevo == true" class="badge badge-danger ml-1">Nuevo</span></p>
                                            <span class="date">{{fechaComentario(item.created_at)}}</span>
                                        </div>
                                    </div>
                                    <p class="text-justify comment">{{item.comentario}}</p>
                                </div>
                            </div>
                            <hr>
                            <!-- CORREOS ENVIADOS -->
                            <h6 class="m-0 mb-1">Correos enviados</h6>
                            <div v-for="(correo) in (informacion && informacion.correos)" 
                                :key="correo.id+'c'" class="list-group">
                                <div v-if="correo.status_id == tiempo.status"
                                    class="list-group-item p-3 m-1">
                                    <p class="m-0">
                                        <span class="text-primary">Asunto: </span>
                                        <span v-text="correo.asunto"></span>
                                    </p>
                                    <p class="m-0">
                                        <span class="text-danger">Emisor: </span>
                                        <span v-text="correo.user.name"></span>
                                    </p>
                                    <hr class="my-1">
                                    <p class="m-0" v-text="correo.mensaje"></p>
                                </div>
                            </div>
                        </div>

                        <div v-if="(informacion && informacion.status_id) == tiempo.status" class="mt-4 d-flex justify-space-between" :class="alinearBotones(tiempo)">
                            <vs-button
                                v-if="tiempo.retroceder == true"
                                warn
                                flat
                                @click="postRetroceder(informacion.id)"
                            >
                                <i class="fas fa-long-arrow-alt-left mr-2"></i> Retroceder
                            </vs-button>
                            <vs-button
                                v-if="tiempo.avanzar == true"
                                success
                                flat
                                @click="postAvanzar(informacion.id, tiempo.status)"
                            >
                                Avanzar <i class="fas fa-long-arrow-alt-right ml-2"></i>
                            </vs-button>
                        </div>  
                    </div>  
                </v-timeline-item>
            </vs-col>
        </vs-row>
        <correo v-model="activeCorre" :correo="correo"></correo>
        <curp v-model="activeCurp" :informacion="informacion" @refreshProcess="getRefresh"></curp>
    </div>

</template>

<script>
import alumnos from '../../../../../api/requests/alumno'
import Crear from '../../../../administracion/promociones/modal/crear.vue'
import correo from './modal/correo.vue'
import curp from './modal/curp.vue'
export default {
    props:[
        'personaId',
        'institucion',
        'informacion',
        'general'
    ],
    data(){
        return{
            comentarios: '',
            correo: [],
            activeCorre: false,
            pasos: [
                {
                    'position': 'left',
                    'status': 1,
                    'title': 'Etapa informes (Prospecto)',
                    'tooltip': 'Cliente potencial que llega a través de alguna activación descrita en la estrategia de promoción de cada Colegio.',
                    'avanzar': true,
                    'retroceder': false,
                    'pagar': false,
                    'inscripcion': false
                },
                {
                    'position': 'right',
                    'status': 2,
                    'title': 'Etapa informes (Interesado)',
                    'tooltip': 'Contacto calificado y validado; tiene una necesidad y parece estar interesado en el Colegio. En lenguaje coloquial, se le conoce como una persona interesada.',
                    'avanzar': true,
                    'retroceder': true,
                    'pagar': false,
                    'inscripcion': false
                },
                {
                    'position':'left',
                    'status': 3,
                    'title': 'Etapa valoración (Aplicante)',
                    'tooltip': 'Aquel interesado que ya comenzó un proceso institucional como llenar solicitud, entrega de informes, entrega de documentación y tienen agendado un examen diagnóstico.',
                    'avanzar': true,
                    'retroceder': true,
                    'pagar': false,
                    'inscripcion': false
                },
                {
                    'position':'right',
                    'status': 4,
                    'title': 'Etapa valoración (Admitido)',
                    'tooltip': 'Todo aquel aplicante que realizó/acreditó el examen diagnóstico o que está admitido al Colegio por cualquier otro medio (promoción, pase directo, etc.)',
                    'avanzar': true,
                    'retroceder': true,
                    'pagar': true,
                    'inscripcion': false
                },
                {
                    'position':'left',
                    'status': 5,
                    'title': 'Etapa inscripción (Inscrito económico)',
                    'tooltip': 'Se divide en dos: inscrito académico y el inscrito económico. El inscrito académico, es aquel alumno que ya acreditó/realizó su examen y ya entregó toda la documentación necesaria. El inscrito económico es aquel que únicamente ha pagado.',
                    'avanzar': false,
                    'retroceder': true,
                    'pagar': false,
                    'inscripcion': true
                }
            ],
            activeCurp: false,
            show_comentarios: [],
            componentKey: 8
        }
    },
    components:{
        correo,
        Crear,
        curp
    },
    methods:{
        getRefresh(){
            
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
        },
        hacerComentarios(i) {
            this.show_comentarios[i] = !this.show_comentarios[i]
            this.componentKey += 1;
        },
        getComentarios (){
            let result = []
            this.pasos.forEach(i => {
                result.push(false)
            })
            this.show_comentarios = result
        },
        alinearBotones(tiempo){
            if(tiempo.avanzar && tiempo.retroceder){
                return 'justify-space-between'
            }else if(tiempo.avanzar){
                return 'justify-end'
            }else if(tiempo.retroceder){
                return 'justify-start'
            }
        },
        fechaComentario(fecha){
            const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
            const dias_semana = ['Domingo', 'Lunes', 'martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
            const d = new Date(fecha)
            const fecha_final = (dias_semana[d.getUTCDay()] + ', ' + d.getUTCDate() + ' de ' + meses[d.getUTCMonth()] + ' de ' + d.getUTCFullYear())
            return fecha_final
        },
        // async getInformacionProcesoAdmision(){
        //     try{
        //         console.log("entro aqui 1")
        //         const instituto = btoa(this.general.datos.institucionId)
        //         const {data: response} = await alumnos.getInformacionProcesoAdmision(this.personaId, this.institucion)
        //         this.informacion = response
        //     }catch(error){
        //         console.log(error)
        //     }
        // },
        async publicarComentario(){
            const loading = this.$vs.loading()
            try{
                const params = {
                    comentario: this.comentarios
                }
                const payload = Object.assign(params)
                const response = await alumnos.publicarComentario(payload, this.informacion.id)
                
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
                loading.close()
                this.getComentarios()
                this.comentarios = ''
            }catch(error){
                loading.close()
                console.log(error)
            }
        },
        abrirCorreoModal(status){
            this.correo = {
                prospecto_id: this.personaId,
                status_id: status
            }
            this.activeCorre =! this.activeCorre
        },
        async postCongelar(id){
            const loading = this.$vs.loading()
            try{
                const response = await alumnos.postCongelar(id)
                
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
        async postReactivar(status, id){
            const loading = this.$vs.loading()
            try{
                const response = await alumnos.postReactivar(status, id)
                
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
        async postDescartar(id){
            const loading = this.$vs.loading()
            try{
                const response = await alumnos.postDescartar(id)
                
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
        async postAvanzar(id, status){
            if(status == '3'){
                this.activeCurp =! this.activeCurp
            }else{
                const formData = new FormData()
                formData.append('confirmacion_vinculacion', '')
                const loading = this.$vs.loading()
                try{
                    const response = await alumnos.postAvanzar(id, formData)
                
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
                    if(response.data.status_id == '5'){
                        location.reload();
                    }
                    this.getComentarios()
                    this.comentarios = ''
                    loading.close()
                }catch(error){
                    console.log(error)
                    loading.close()
                }

            }
        },
        async postRetroceder(id){
            const loading = this.$vs.loading()
            try{
                const response = await alumnos.postRetroceder(id)
                if(response.data.status_id == '4'){
                    location.reload();
                }
                this.getComentarios()
                this.comentarios = ''
                this.$emit('refreshComponent', this.personaId, 'seguimiento')
                loading.close()
            }catch(error){
                console.log(error)
                loading.close()
            }
        },
    },
    watch:{
        datos(){
            this.getInformacion()
        },
        general(){
            if(this.general.proceso == 'seguimiento'){
                this.getComentarios()
            }
        },

    }
}
</script>

<style scoped>
.cardAlerta{
    background-color: rgba(25, 91, 255, 0.1);
    color: rgb(25,91,255);
    padding: 1rem;
    border-radius: 10px;
}
</style>